/**
 * @zag/notifications/ui
 *
 * Frontend notification module providing:
 * - NotificationGatewayClient — Socket.IO client for real-time notification events
 * - NotificationsService — HTTP client + reactive list resource
 * - WebhookEndpointService — HTTP client for webhook endpoint management
 * - NotificationBellComponent — top-bar bell with badge + panel overlay
 * - NotificationItemComponent — shared notification item (panel + list)
 * - NotificationListComponent — full-page notification list with tabs
 * - NotificationDetailComponent — single notification detail with deliveries
 * - NotificationPreferencesComponent — user in-app notification preferences
 */

export * from './lib/gateways';
export * from './lib/services/notifications.service';
export * from './lib/services/webhook-endpoint.service';
export * from './lib/components/notification-bell/notification-bell.component';
export * from './lib/components/notification-item/notification-item.component';
export * from './lib/components/notification-list/notification-list.component';
export * from './lib/components/notification-detail/notification-detail.component';
export * from './lib/components/notification-preferences/notification-preferences.component';
export * from './lib/components/channel-config/channel-config.component';
export * from './lib/webhook-edit/webhook-edit.component';
export * from './lib/webhook-edit/webhook-edit.facade';
export * from './lib/webhook-edit/webhook-detail.metadata';
